import { NSARouterMakerResult, } from 'namirasoft-account-react';
import { PaymentEntities } from '../PaymentEntities';
import { PaymentLayout } from '../PaymentLayout';
import { PaymentProps } from '../PaymentProps';

export interface InvoiceListPageState
{ }

export interface InvoiceListPageProps extends NSARouterMakerResult, PaymentProps
{ }

function InvoiceListPage(props: InvoiceListPageProps)
{
    return (
        <PaymentLayout {...props}
            action={{
                title: '',
                description: 'A detailed list of all your invoices, including their statuses.',
                menus: {}
            }}
            pages={{
                entity: PaymentEntities.Invoice(props),
                list: {
                    ui: {}
                }
            }
            }
        >
            <>
            </>
        </ PaymentLayout >

    );
}

export default InvoiceListPage;